import * as Icon from './photoUrls';

// NavBar Connect
interface Connect {
  light: string;
  dark: string;
  link: string;
}

export const connect: Connect[] = [
  {
    light: Icon.linkedIn,
    dark: Icon.linkedInDark,
    link: 'https://www.linkedin.com/in/ejiroghene-alexander-egbedi-74a37b219/',
  },
  {
    light: Icon.github,
    dark: Icon.githubDark,
    link: 'https://github.com/Billions94',
  },
  {
    light: Icon.instagram,
    dark: Icon.instagramDark,
    link: 'https://www.instagram.com/billions_e/',
  },
];

// Projects Screen
export interface Screen {
  name: string;
}

export const lexyspaceScreen: Screen[] = [
  {
    name: Icon.beforeLogin,
  },
  {
    name: Icon.signup,
  },
  {
    name: Icon.main,
  },
  {
    name: Icon.music,
  },
  {
    name: Icon.post,
  },
  {
    name: Icon.message,
  },
  {
    name: Icon.profile,
  },
];

export const spoftiyScreen: Screen[] = [
  {
    name: Icon.home,
  },
  {
    name: Icon.album,
  },
  {
    name: Icon.search,
  },
  {
    name: Icon.liked,
  },
];

export const portfolioScreen: Screen[] = [
  {
    name: Icon.screen1,
  },
  {
    name: Icon.screen2,
  },
  {
    name: Icon.screen3,
  },
  {
    name: Icon.screen4,
  },
];

interface Tech {
  icon: string;
}

export const lexySpaceTech: Tech[] = [
  {
    icon: Icon.typescript,
  },
  {
    icon: Icon.react,
  },
  {
    icon: Icon.redux,
  },
  {
    icon: Icon.nodeJS,
  },
  {
    icon: Icon.mongoDB,
  },
  {
    icon: Icon.scss,
  },
  {
    icon: Icon.express,
  },
  {
    icon: Icon.vsCode,
  },
  {
    icon: Icon.bootstrap,
  },
];

export const spotifyTech: Tech[] = [
  {
    icon: Icon.javascript,
  },
  {
    icon: Icon.react,
  },
  {
    icon: Icon.redux,
  },
  {
    icon: Icon.scss,
  },
  {
    icon: Icon.vsCode,
  },
  {
    icon: Icon.bootstrap,
  },
  {
    icon: Icon.restApis,
  },
];

export const portfolioTech: Tech[] = [
  {
    icon: Icon.typescript,
  },
  {
    icon: Icon.react,
  },
  {
    icon: Icon.recoil,
  },
  {
    icon: Icon.scss,
  },
  {
    icon: Icon.vsCode,
  },
  {
    icon: Icon.bootstrap,
  },
];
export const thePillar: Tech[] = [
  {
    icon: Icon.typescript,
  },
  {
    icon: Icon.react,
  },
  {
    icon: Icon.recoil,
  },
  {
    icon: Icon.scss,
  },
  {
    icon: Icon.vsCode,
  },
  {
    icon: Icon.aws,
  },
  {
    icon: Icon.awsAmplify,
  },
  {
    icon: Icon.graphQL,
  },
  {
    icon: Icon.dynamoDB,
  },
  {
    icon: Icon.bootstrap,
  },
];

export interface Project {
  name: string;
  link?: string;
  logo: string;
  tech: Tech[];
  className: string;
  classNameDark: string;
  description: string;
  bg: string;
  fontSize: string;
}

const className = 'project';
const classNameDark = 'projectDark';

const seeThroughColors = [
  'rgba(206, 206, 206, 0.57)',
  'rgba(45, 221, 1, 0.57)',
  'rgb(209, 111, 55, 0.57)',
];

export const projects: Project[] = [
  {
    name: 'LexySpace',
    link: 'https://lexyspace.vercel.app',
    logo: Icon.lexySpaceLogo,
    tech: lexySpaceTech,
    className,
    classNameDark,
    description:
      'LexySpace is a social media app that allows you to share photos, videos, and links with friends and family.',
    bg: seeThroughColors[0],
    fontSize: '40px',
  },
  {
    name: 'Spoftiy Clone',
    link: 'https://spotify-fe-main.vercel.app',
    logo: Icon.spotifyLogo,
    tech: spotifyTech,
    className: className + 2,
    classNameDark: classNameDark + 2,
    description:
      'Spotify-fe-main is a clone of the Spotify app that allows you to search for songs',
    bg: seeThroughColors[1],
    fontSize: '70px',
  },
  {
    name: 'The Pillar',
    // link: 'Coming Soon.......',
    logo: Icon.thePillar,
    tech: thePillar,
    className: className + 3,
    classNameDark: classNameDark + 3,
    description:
      'Pillar is a Afriacn E-commerce app that allows you to buy, sell, and manage your products and services.',
    bg: seeThroughColors[2],
    fontSize: '50px',
  },
];

//Bio
interface Bio {
  heading: string;
  bio1: string;
  bio2: string;
  bio3: string;
}

export const bio: Bio[] = [
  {
    heading: `A curious driven FullStack Web Developer.`,

    bio1: `As a Full Stack Developer at ALLES.AUTO, I design and implement web applications using Node.js, MariaDB, and Git, as well as other technologies such as React, Next.js, GraphQL, and Docker. 
          I work with a team of developers and engineers to deliver high-quality products that meet the needs and expectations of our clients and users.
          Logical and results-driven Software Developer dedicated to building and optimizing user-focused websites for customers with various business objectives. 
          Judicious and creative when crafting effective websites, apps and platforms to propel competitive advantage and revenue growth. 
          Technically proficient and analytical problem solver with calm and focused demeanor.`,

    bio2: `Studied Telecommunications and Electronics Engineering in Riga Technical University 🇱🇻`,

    bio3: `I'm happiest when I'm creating, learning, exploring and thinking about how to improve things. Currently working on improving my Docker and AWS skills.
          At my spare time when I'm not coding or thinking about coding, I enjoy a walk on the beach, road trips while listening to blues, just to mention a few.`,
  },
];

//Hobbies
interface Hobbies {
  name: string;
}

export const hobbies: Hobbies[] = [
  {
    name: 'Dancing',
  },
  {
    name: 'Coding and solving problems',
  },
  {
    name: 'Hiking',
  },
  {
    name: 'Travelling',
  },
  {
    name: 'Reading',
  },
  {
    name: 'Cracking jokes',
  },
];

//Travel
interface TravelHistory {
  country: string;
  city: string;
}

export const travelHistory: TravelHistory[] = [
  {
    country: 'United Kingdom',
    city: 'London',
  },
  {
    country: 'The Netherlands',
    city: 'Amsterdam, Utrecht, Venlo',
  },
  {
    country: 'France',
    city: 'Paris',
  },
  {
    country: 'Sweden',
    city: 'Stockholm',
  },
  {
    country: 'Denmark',
    city: 'København',
  },
  {
    country: 'Poland',
    city: 'Warsaw, Lublin',
  },
  {
    country: 'Estonia',
    city: 'Tallinn',
  },
  {
    country: 'Latvia',
    city: 'Riga, Jurmala, Jelgava',
  },
  {
    country: 'Lithuania',
    city: 'Kaunas, Vilnius',
  },
  {
    country: 'Ukraine',
    city: 'Kyiv, Kharkiv, Sumy',
  },
  {
    country: 'Italy',
    city: 'Milan',
  },
  {
    country: 'Belgium',
    city: 'Leuven',
  },
];

//Skills
interface Skill {
  name: string;
  icon: string;
}

export const skills: Skill[] = [
  {
    name: 'Javascript',
    icon: Icon.javascript,
  },
  {
    name: 'Typescript',
    icon: Icon.typescript,
  },
  {
    name: 'React',
    icon: Icon.react,
  },
  {
    name: 'NodeJS',
    icon: Icon.nodeJS,
  },
  {
    name: 'Express',
    icon: Icon.express,
  },
  {
    name: 'MongoDB',
    icon: Icon.mongoDB,
  },
  {
    name: 'Css',
    icon: Icon.css,
  },
  {
    name: 'Scss',
    icon: Icon.scss,
  },
  {
    name: 'Html',
    icon: Icon.html,
  },
  {
    name: 'Redux',
    icon: Icon.redux,
  },
  {
    name: 'Git',
    icon: Icon.git,
  },
  {
    name: 'GitHub',
    icon: Icon.gitHub,
  },
  {
    name: 'NPM',
    icon: Icon.npm,
  },
  {
    name: 'Recoil',
    icon: Icon.recoil,
  },
  {
    name: 'Docker',
    icon: Icon.docker,
  },
  {
    name: 'PostgreSQL',
    icon: Icon.postgreSQL,
  },
  {
    name: 'Vs Code',
    icon: Icon.vsCode,
  },
  {
    name: 'Heroku',
    icon: Icon.heroku,
  },
  {
    name: 'Bootstrap',
    icon: Icon.bootstrap,
  },
  {
    name: 'Rest APIs',
    icon: Icon.restApis,
  },
  {
    name: 'AWS',
    icon: Icon.aws,
  },
  {
    name: 'GraphQL',
    icon: Icon.graphQL,
  },
  {
    name: 'DynamoDB',
    icon: Icon.dynamoDB,
  },
  {
    name: 'Aws Amplify',
    icon: Icon.awsAmplify,
  },
  {
    name: 'Postman',
    icon: Icon.postman,
  },
];
